import Swal from 'sweetalert2';
import UserProfile, {EnumProfile} from '@/framework/base/classes/UserProfile';
import {storeSession} from '@/generated/stores';
import Dialog from '@/generated/classes/Dialog';
import {FwkButtons, FwkControls, RessourceFwkButton, RessourceFwkControl} from '@/ressources/globalRessources';
import {type EditDialog} from '@/framework/base/helpers/Dialogs';
import SectionAlert, {openAlert} from '@/framework/base/components/SectionAlert.vue';

export class Alerts {

    public static saveOrCancel(): Promise<boolean> {
        const dialog = new Dialog();
        dialog.label = RessourceFwkControl(FwkControls.SAVE_OR_CANCEL).label;
        dialog.buttons = [];
        dialog.buttons.push(RessourceFwkButton(FwkButtons.ENREGISTRER).label);
        dialog.buttons.push(RessourceFwkButton(FwkButtons.IGNORER).label);
        return new Promise((resolve) => {
            openAlert(dialog).then((result: string) => {
                if (result == RessourceFwkButton(FwkButtons.ENREGISTRER).label) {
                    resolve(true)
                } else if (result == RessourceFwkButton(FwkButtons.IGNORER).label) {
                    resolve(false)
                }
            });
        });
    }

    public static cancelRoute(): Promise<boolean> {
        const dialog = new Dialog();
        dialog.label = RessourceFwkControl(FwkControls.CANCEL_ROUTE).label;
        dialog.buttons = [];
        dialog.buttons.push(RessourceFwkButton(FwkButtons.ANNULER).label);
        dialog.buttons.push(RessourceFwkButton(FwkButtons.CONTINUER).label);
        return new Promise((resolve) => {
            openAlert(dialog).then((result: string) => {
                if (result == RessourceFwkButton(FwkButtons.ANNULER).label) {
                    resolve(true)
                } else if (result == RessourceFwkButton(FwkButtons.CONTINUER).label) {
                    resolve(false)
                }
            });
        });
    }

    public static alertDelete(label?: string): Promise<boolean> {
        const dialog = new Dialog();
        dialog.label = label ?? RessourceFwkControl(FwkControls.DELETE).label;
        dialog.buttons = [];
        dialog.buttons.push(RessourceFwkButton(FwkButtons.CONFIRMER).label);
        dialog.buttons.push(RessourceFwkButton(FwkButtons.ANNULER).label);
        return new Promise((resolve) => {
            openAlert(dialog).then((result: string) => {
                if (result == RessourceFwkButton(FwkButtons.CONFIRMER).label) {
                    resolve(true)
                }
            });
        });

    }

    public static message(dialog: Dialog): Promise<boolean> {
        if (!dialog.buttons || dialog.buttons.length == 0) {
            dialog.buttons = [];
            dialog.buttons.push(RessourceFwkButton(FwkButtons.OK).label);
        }
        return new Promise((resolve) => {
            openAlert(dialog).then((result: string) => {
                if (result == RessourceFwkButton(FwkButtons.OK).label) {
                    resolve(true)
                }
            });
        });
    }

    private static concat = '';

    public static debug(html: string): Promise<boolean> {
        if (this.concat == '') {
            this.concat = html;
        }
        return new Promise((resolve) => {
            const user = storeSession.connectedUser;
            if (user && (import.meta.env.VITE_VUE_APP_PRODUCTION == 'false' || UserProfile.hasProfile(user, EnumProfile.canEdit))) {
                Swal.fire({
                    html: this.concat,
                    backdrop: true,
                    confirmButtonColor: '#95a21d',
                    confirmButtonText: 'DEBUG',
                    allowOutsideClick: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.concat = '';
                    }
                    resolve(true)
                })
            } else {
                resolve(true)
            }
        });
    }

    private static cbEditDialog: EditDialog;

    public static setEditDialog(editDialog: EditDialog) {
        Alerts.cbEditDialog = editDialog;
    }

    private static editDialog(dialog: Dialog, event?: PointerEvent): Promise<boolean> {
        return new Promise((resolve) => {
            if (event && event.ctrlKey && Alerts.cbEditDialog) {
                Alerts.cbEditDialog(dialog).then(() => {
                    resolve(true);
                })
            } else {
                resolve(false);
            }
        });
    }
}
